import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=765d11bf&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=765d11bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d11bf",
  null
  
)

export default component.exports